export var RelativeDateDisplayMetric = /*#__PURE__*/function (RelativeDateDisplayMetric) {
  RelativeDateDisplayMetric["SECONDS"] = "seconds";
  RelativeDateDisplayMetric["MINUTES"] = "minutes";
  RelativeDateDisplayMetric["HOURS"] = "hours";
  RelativeDateDisplayMetric["DAYS"] = "days";
  RelativeDateDisplayMetric["MONTHS"] = "months";
  return RelativeDateDisplayMetric;
}({});